import { ETaxVariant } from 'cashbox';

import { TNormalizedEntity } from './interfaces';

export const filterByTax = (
  entities?: Array<TNormalizedEntity>,
  tax?: ETaxVariant
): Array<TNormalizedEntity> =>
  entities?.filter(({ tax_system }) => (tax ? tax_system === tax : true)) ?? [];
